module.exports = __webpack_public_path__ + "static/pro-life-6359b17cfc69c9e4781398c00e3d7d18.jpg";